var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnddump(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "38px",
    viewBox: "0 0 104 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDE9Bicon/enddump2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-29",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    x: 8,
    y: 31,
    width: 67,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-31",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    transform: "translate(67.000000, 26.500000) rotate(-270.000000) translate(-67.000000, -26.500000) ",
    x: 62.5,
    y: 26.5,
    width: 9,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.646923,9 L103,19.3531095 L103,31 L81,31 L81,9 L94.646923,9 Z",
    id: "Combined-Shape",
    stroke: "#4F7CB4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-25",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 96,
    cy: 33,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-29",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 22,
    cy: 33,
    r: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-30",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    transform: "translate(35.344872, 17.081636) rotate(-11.000000) translate(-35.344872, -17.081636) ",
    x: 3.34487236,
    y: 7.58163638,
    width: 64,
    height: 19
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-26",
    stroke: "#4F7CB4",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 9,
    cy: 33,
    r: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnddump);
export default __webpack_public_path__ + "static/media/enddump.515d1162be01fd4e40882c262fbbe908.svg";
export { ForwardRef as ReactComponent };